import { flushSync } from 'react-dom'

export function isSwitchboardSaveTargetCurrent(
  activeExtensionDialPlan: number,
  loadedExtensionDialPlan: number,
): boolean {
  return activeExtensionDialPlan === loadedExtensionDialPlan
}

/**
 * Ensure active form fields commit pending edits before save reads canvas state.
 */
export function flushPendingInputBeforeSave(
  flushPendingDataChange: () => void,
): void {
  if (typeof document !== 'undefined') {
    const activeElement = document.activeElement
    if (
      activeElement instanceof HTMLInputElement ||
      activeElement instanceof HTMLTextAreaElement ||
      activeElement instanceof HTMLSelectElement
    ) {
      // Force blur-committed React updates through before we flush canvas data.
      try {
        flushSync(() => {
          activeElement.blur()
        })
      } catch {
        // In rare cases (e.g. mid-render), flushSync can throw.
        // Best-effort fallback still blurs the field so value commits.
        activeElement.blur()
      }
    }
  }

  flushPendingDataChange()
}
